import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Component, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {environment} from '../../../environments/environment';

@Component({
  selector: 'app-checkout-success',
  styleUrls: ['./checkout-success.component.scss'],
  templateUrl: './checkout-success.component.html',
})
export class CheckoutSuccessComponent implements OnInit {

  constructor(private http: HttpClient, private activatedRoute: ActivatedRoute) {}

  public ngOnInit(): void {

    this.activatedRoute.queryParams.subscribe(params => {
        const body = {
          id: params.Id,
          order: params.Order,
          acode: params.ACode,
          ccode: params.CCode,
          amount: params.Amount,
          field1: params.Fild1,
          field2: params.Fild2,
          field3: params.Fild3,
          sign: params.Sign
        };

        const httpOptions = {
          headers: new HttpHeaders({'Content-Type': 'application/json'}),
        };

        this.http.post(`${environment.backendApiUrl}/v1/checkout/finalize`, body, httpOptions).subscribe();
      });
  }

}
